export default __webpack_public_path__ + "static/media/ayelet.10c82090.png";